module.exports = __webpack_public_path__ + "img/7-None.8496a1b6.png";